export default {
  GET_ALLIANZ_DEPOSIT_OPERATION_DATES_QUERY: Symbol.for('GET_ALLIANZ_DEPOSIT_OPERATION_DATES_QUERY'),
  GET_ALLIANZ_WITHDRAWALS_OPERATION_DATES_QUERY: Symbol.for('GET_ALLIANZ_WITHDRAWALS_OPERATION_DATES_QUERY'),
  ALLIANZ_OPERATION_DATES_REPOSITORY: Symbol.for('ALLIANZ_OPERATION_DATES_REPOSITORY'),
  ALLIANZ_OPERATION_DATES_STATE_MANAGER: Symbol.for('ALLIANZ_OPERATION_DATES_STATE_MANAGER'),
};
